import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const VendorsListSkeleton = () => {
    const gridItems = Array.from({ length: 12 });

    return (
        <Grid container spacing={2}>
            {gridItems.map((_, index) => (
                <Grid item size={{xs:12,sm:6,lg:4}}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        animation="wave"
                        height={220}
                        style={{borderRadius:16}}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default VendorsListSkeleton;
